export function DetectClickArea(containerRef: React.MutableRefObject<HTMLElement | undefined>, target: any) {
  if (containerRef.current && target instanceof Node && !containerRef.current.contains(target)) {
    return false;
  }

  return true;
}
